module.exports = __webpack_public_path__ + "img/cove.14458034.jpg";